/**
 * This index.js file is the entry point for your component and
 * is referenced from package.json. It's best to keep it lightweight
 * and do all of your work in component and subcomponent files.
 **/

export {default} from './components/InputTel/InputTel';
